import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ServerService} from './ServerService';
import {NumeroWhatsapp} from '../pedidos/objetos/NumeroWhatsapp';

@Injectable({
  providedIn: 'root'
})
export class WhatsappV4Service extends ServerService {
  constructor(http: HttpClient) {
    super(http);
  }

  obtenhaPolitica(empresa: any, numeroWhatsapp?: NumeroWhatsapp): Promise<any> {
    const params: any = {
      empresaId: empresa.id
    };

    if (numeroWhatsapp && numeroWhatsapp.id) {
      params.numeroWhatsappId = numeroWhatsapp.id;
    }

    return this.obtenha('/whatsapp-v4/limites', params);
  }

  listeDispositivos(empresa: any): Promise<any> {
    return this.obtenha('/whatsapp-v4/sessoes', {empresaId: empresa.id});
  }

  salvePolitica(empresa: any, numeroWhatsapp: NumeroWhatsapp): Promise<any> {
    return this.facaPut('/whatsapp-v4/limites', {
      empresaId: empresa.id,
      numeroWhatsappId: numeroWhatsapp.id,
      versaoExtensao: numeroWhatsapp.versaoExtensao,
      limiteDiario: numeroWhatsapp.limiteDiario,
      intervaloStatusPedidoSegundos: numeroWhatsapp.intervaloStatusPedidoSegundos,
      aplicarIntervaloConfirmacaoLoja: numeroWhatsapp.aplicarIntervaloConfirmacaoLoja,
      janelaInicioHora: numeroWhatsapp.janelaInicioHora,
      janelaFimHora: numeroWhatsapp.janelaFimHora,
      pausado: numeroWhatsapp.pausado
    });
  }
}
